import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-popover-favourites',
  templateUrl: './popover-favourites.component.html',
  styleUrls: ['./popover-favourites.component.scss'],
})
export class PopoverFavouritesComponent implements OnInit {

  public popOverContent: string;
  public popOverTitle;
  public FavouritesDismissTimer:number;
  
  constructor(
    public eventsService: EventsService,
    public config: ConfigService,
    public navigator: Navigator,
    public viewCtrl: ModalController,
  ){
     this.FavouritesDismissTimer = !!this.config.getConfig().FAVOURITES_DISMISS_TIMER ? this.config.getConfig().FAVOURITES_DISMISS_TIMER : 2000; 
  }

  ngOnInit(){
    this.popOverTitle = 'Favourites Added'
    this.popOverContent= this.navigator.activePopovers[this.navigator.activePopovers.length-1].componentProps.data.message;
    setTimeout(() => this.closePopover(), this.FavouritesDismissTimer);
  }

  closePopover() {
    this.navigator.dismissAll();
   
  }

}
